export default {
  en: {
    // Error Handling
    ERROR_TITLE: "We’re sorry. Insight has failed to load your requested page.",
    ERROR_MESSAGE_LINE_1:
      "Please navigate away from the page and return to try again. If you see this message a second time while doing the same action please contact our Customer Service team to report the issue and we will resolve it for you as soon as possible.",

    // Validation message
    MINIMUM_8_CHARACTERS: "8 characters minimum",
    INCLUDE_UPPERCASE_LETTER: "include an uppercase letter",
    INCLUDE_LOWERCASE_LETTER: "include a lower case letter",
    INCLUDE_NUMBER_OR_SPECIAL_CHARACTER: "include a number or a special character",
    PASSWORD_CONFIRMATION_MATCHES: "password confirmation matches",

    // Forms
    CHOOSE_NEW_PASSWORD: "Choose New Password",
    CONFIRM_NEW_PASSWORD: "Confirm New Password",
  },
};
